/**
 * created by xcc
 阵地类型
 *
 */
import React from 'react';
import BaseComponent from "../../../../../../base/BaseComponent";
import {getPositionTypeByDivision} from "../../../../../newMediaMatrix/actions/actions";

export default class PlatformSelect extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            divisionData: [],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getPlatformData();
        if(this.props.fieldProps.value) {
            this.props.fieldProps.getExtendsField(this.props.fieldProps.value);
        }
    }

    getPlatformData() {
        let {divisionName} = this.props.fieldProps.formInfoData;
        getPositionTypeByDivision({divisionName: divisionName}, (data) => {
            let divisionData = [];
            if (data && data.length) {
                divisionData = data.map(item => {
                    return {
                        ...item,
                        key: item.id,
                        label: item.name
                    }
                })
            }
            this.setState({
                divisionData
            })
        })
    }

    render() {
        let {formInfoData, positionTypeId, platformDivide} = this.props.fieldProps;
        let {divisionData} = this.state;
        let platformLogo = divisionData.find(item => item.id === positionTypeId)?.logo;
        const extra = platformLogo && <span><img src={platformLogo} style={{
            width: 16,
            height: 16,
            verticalAlign: "text-bottom",
            marginRight: 5
        }}/></span>
        const divisionName = formInfoData?.divisionName ? <span>（{formInfoData.divisionName}）</span> : "";
        return (
            <div className={"position-manage-detail-value"} style={{height: 60}}>
                {extra}{formInfoData.positionTypeName}{platformDivide ? null : divisionName}
            </div>
        )
    }
}